import React from 'react'

class ContinueButton extends React.Component {

  render() {
    if (this.props.enabled) {
      return(
        <button className='btn btn-green btn-lg' onClick={this.props.onClick}>
          Continue
        </button>
      )
    } else {
      return(
        <button className='btn btn-green btn-lg' disabled={ true }>
          Continue
        </button>
      )
    }
  }
}

export default ContinueButton
